export enum MemberType {
  Single = 1,
  Dual,
  Affiliate,
  Junior,
  Service,
  Lifetime,
  LifetimeDual
}
